import React from "react";
import { string, number } from "prop-types";

const Twitter = ({ color = "#333", width = 21, height = 21 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24">
    <path
      id="a"
      fill={color}
      fillRule="evenodd"
      d="M19.93 8c.026.103.039.27.039.5 0 1.846-.456 3.628-1.367 5.346-.938 1.82-2.253 3.27-3.946 4.346C12.807 19.397 10.685 20 8.29 20 5.997 20 3.901 19.397 2 18.192c.286.026.612.039.977.039A8.213 8.213 0 0 0 8.094 16.5c-.912 0-1.712-.263-2.403-.788a4.018 4.018 0 0 1-1.425-1.981c.26.025.507.038.742.038.364 0 .729-.038 1.094-.115a4.143 4.143 0 0 1-2.344-1.423c-.625-.744-.938-1.59-.938-2.539v-.077a3.906 3.906 0 0 0 1.836.539 4.505 4.505 0 0 1-1.328-1.462A3.833 3.833 0 0 1 2.82 6.75c0-.705.196-1.378.586-2.02a11.276 11.276 0 0 0 3.73 3 11.493 11.493 0 0 0 4.708 1.232 5.522 5.522 0 0 1-.078-.924c0-.717.182-1.39.546-2.019a3.983 3.983 0 0 1 1.485-1.48A4.01 4.01 0 0 1 15.828 4c.6 0 1.152.115 1.66.346.508.23.957.539 1.348.923.937-.18 1.81-.5 2.617-.961-.312.948-.911 1.692-1.797 2.23A8.917 8.917 0 0 0 22 5.885 8.94 8.94 0 0 1 19.93 8z"
    />
  </svg>
);

Twitter.propTypes = {
  color: string,
  width: number,
  height: number
};

export default Twitter;
